import {createAction, ActionCreator} from '@packages/utilities/create-action';
import {List} from 'immutable';

import {
  DYN_BINDING_CHANGED,
  BINDING_CONTEXT_CURRENT_ITEM_UPDATED,
  BINDING_CONTEXT_ITEM_SWITCHED,
} from '@packages/systems/designer/actions';

import type {ItemRecordType} from '@packages/systems/core/records/ItemRecord';
import {Expression} from '@packages/systems/wfdl-ast';
import {DesignerActionFromCreator} from '@packages/systems/designer/flux';

export const bindingChanged: ActionCreator<
  typeof DYN_BINDING_CHANGED,
  {
    id: string;
    data: Expression;
    children: null | Expression;
  }
> = createAction(DYN_BINDING_CHANGED);

export const bindingContextCurrentItemUpdated: ActionCreator<
  typeof BINDING_CONTEXT_CURRENT_ITEM_UPDATED,
  string
> = createAction(BINDING_CONTEXT_CURRENT_ITEM_UPDATED);

export const bindingContextCurrentItemSwitched: ActionCreator<
  typeof BINDING_CONTEXT_ITEM_SWITCHED,
  {
    direction: string;
    items: List<ItemRecordType>;
  }
> = createAction(BINDING_CONTEXT_ITEM_SWITCHED);

export type BindingContextCurrentItemSwitchedAction = DesignerActionFromCreator<
  typeof bindingContextCurrentItemSwitched
>;
